import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { BodyHealthComponent } from './BodyHealth.component';
import { WellnessWrapper } from '../WellnessWrapper.component';
var BodyHealth = function () {
    return (_jsx(WellnessWrapper, { children: _jsx(BodyHealthComponent, {}) }));
};
export default BodyHealth;
